import {configureStore} from '@reduxjs/toolkit';
import menuReducer from 'units/dashboard/store/menuSlice';
import authReducer from 'units/auth/store/authSlice';
import orgInfoReducer from 'units/chatbot/store/organizationInfoSlice';
import userSlice from 'units/dashboard/store/userSlice';
import botReducer from "units/client/store/botSlice";

const store = configureStore({
    reducer: {
        menu: menuReducer,
        auth: authReducer,
        organizationInfo: orgInfoReducer,
        userInfo:userSlice,
        botInfo: botReducer,

    },
});

export default store;
